<template>
    <div class="text-[var(--text)]  gap-2 p-4 bg-[var(--fundoForm)] rounded-[10px] bg-opacity-[0.55] flex flex-col w-full"> 
      <div class="w-full flex justify-between">
        <h3 class="text-[var(--titulo)] text-[18px] font-bold">Calendario</h3>
        <AppButton
          class="self-end text-[var(--text)]"
          v-bind:visibility="true"
          left_icon="fa-regular fa-circle-xmark fa-xl"
          emitType="close"
          @close="close"
          :width="23"
          :height="23"
        />
    </div>
    <!-- hide-view-selector -->
    <div style="height: 500px">
        <vue-cal
            id="vuecal"
            :disable-views="['years', 'year']"
            time
            active-view="week"
            :time-step="30"
            :time-from="6*60"
            :time-to="22*60"
            :time-cell-height="20"
            hide-weekends
            :day-format="dayFormat"
            locale="pt-pt"
            no-event-text=" "
            watchRealTime
            snapToTime
            :events="events"
            events-on-month-view="short"
            >
            <template #arrow-prev>
                <Icon class="edit-icon" icon="lucide:arrow-left" />
            </template>
            <template #arrow-next>
                <Icon class="edit-icon" icon="lucide:arrow-right" />
            </template>
        </vue-cal>
    </div>
    <div class="w-full">
        <AppTablePagination  :visibility="true"  table_title="Serviços"
          @row-clicked="select_servico" @close="close_table" :urlString="`ordemservico/filter`" :data="filter_data"
          :refresh="refresh" @refreshed="refresh = false" :filterData="filtroData" :order_by="order_by"
          :page_size="page_size" :filterBtn="true" @open-filter="show_filter_popup = true" />
      </div>
</div>
</template>
    
<script>
import VueCal from 'vue-cal';
import 'vue-cal/dist/vuecal.css';
import AppButton from "@/components/updated/button.vue";
import { toast } from "vue3-toastify";
import AppTablePagination from "@/components/tablePagination/tablePagination.vue";

export default {
  components: { 
    VueCal,
    AppButton,
    AppTablePagination
    },
    name: "MyCalendar",
  data() {

    return {
        tecnico: null,
        events: [
            {
            start: '2025-04-18 10:35',
            end: '2025-04-18 11:30',
            title: 'Doctor appointment',
            content: '<i class="icon material-icons">local_hospital</i>',
            class: 'health'
            }],
        zona: null,

        dayFormat: (day) => {
        toast(day)
        const weekdays = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb']; // Abreviações dos dias da semana
        const date = new Date(day);

        const dayOfMonth = String(date.getDate()).padStart(2, '0'); // Obtém o dia do mês
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Obtém o mês, +1 porque o índice começa em 0
        const year = date.getFullYear(); // Obtém o ano
        const weekday = weekdays[date.getDay()]; // Obtém o nome abreviado do dia da semana

        return `${dayOfMonth}/${month}/${year} (${weekday})`; // Retorna o formato "DD/MM/YYYY (ddd)"
      }
    };
  },

  mounted() {
    this.scrollToHour(4)
  },

  methods: {
    scrollToHour(hour) {
        const calendar = document.querySelector('#vuecal .vuecal__bg')
        calendar.scrollTo({ top: hour * 20, behavior: 'smooth' })
    } 
    }
};

</script>

<style scoped>
.vuecal {
  font-size: 14px;
}


.text-white {
  color: var(--label);
}

.text-black {
  color: var(--text);
}
</style>
